import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CallButton } from './CallButton';
import { business } from '../data/content';
import { useEstimate } from '../contexts/EstimateContext';
export function PromiseCta() {
  const {
    openEstimate
  } = useEstimate();
  return <section id="promise" className="scroll-mt-20 bg-stone-soft py-20 md:py-24" data-id="element-234" data-mp="3edmj5h7mpfsk">
      <div className="mx-auto flex max-w-2xl flex-col items-center px-5 text-center md:px-8" data-id="element-235" data-mp="3efp7zxx1p2vp">
        <ShieldCheckIcon className="h-10 w-10 text-leaf" aria-hidden="true" data-id="element-236" data-mp="2hpoitxsrkkdv" />
        <h2 className="mt-5 font-display text-3xl font-bold text-forest md:text-5xl" data-id="element-237" data-mp="2mn87zsr02hkl">Our Promise to You</h2>
        <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-238" data-mp="2qmyx7s0vopn0">
          Fair price, guaranteed work. If something isn’t right, we fix it. No pressure, no games.
        </p>
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:gap-5" data-id="element-239" data-mp="5x9jjibwv9vw">
          <button type="button" onClick={() => openEstimate()} className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-brick px-7 py-4 text-base font-semibold text-white shadow-sm transition-[background-color,transform] duration-150 ease-out hover:bg-brick-dark active:scale-[0.98] md:text-lg" data-id="element-240" data-mp="aw4dngfbwkvb">
            Get My Free Estimate
          </button>
          <CallButton size="lg" label={business.phoneDisplay} className="!bg-white !text-forest ring-1 ring-forest/25 hover:!bg-forest/5" data-id="element-241" data-mp="21y9bqcihc5ps" />
        </div>
      </div>
    </section>;
}